// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import TrashLoadMoreButton from './TrashLoadMoreButton';
import OrchestratedList from '../../../../../list/OrchestratedList';
import TrashElementList from './TrashElementList';

const INITIAL_RENDER_SIZE = 10;

const TrashTabContent = (props) => {
    const { trashListContentIds, getInitialElementsVisibility } = props;
    const [isContentFullyRendered, setIsContentFullyRendered] = React.useState(false);

    const initialElementsVisibility = getInitialElementsVisibility(trashListContentIds);

    return (
        <div className="TrashTabContent">
            <OrchestratedList
                childElementIds={trashListContentIds}
                initialRenderSize={INITIAL_RENDER_SIZE}
                renderIncrement={10}
                batchRenderAdditionalContent={true}
                onOrchestrationStart={() => setIsContentFullyRendered(false)}
                onOrchestrationEnd={() => setIsContentFullyRendered(true)}
            >
                {(childElementIds) => (
                    <TrashElementList
                        {...props}
                        childElementIds={childElementIds}
                        initialElementsVisibility={initialElementsVisibility}
                    />
                )}
            </OrchestratedList>
            <TrashLoadMoreButton {...props} isContentFullyRendered={isContentFullyRendered} />
        </div>
    );
};

TrashTabContent.propTypes = {
    trashElementGroups: PropTypes.array,
    currentBoardId: PropTypes.string,
    trashListOrderedContent: PropTypes.object,
    trashListContentIds: PropTypes.array,
    placeholderProps: PropTypes.object,
    getInitialElementsVisibility: PropTypes.func,
};

export default TrashTabContent;
